export const getMediaBaseUrl = () => {
  // Prefer the dedicated media URL (uploads host) if configured
  const rel = process.env.REACT_APP_BACKEND_URL_REL || process.env.REACT_APP_BACKEND || "";
  if (rel) {
    let base = rel.endsWith("/") ? rel.slice(0, -1) : rel;
    // strip trailing /uploads so callers can append /uploads/<path>
    base = base.replace(/\/uploads$/, "");
    return base;
  }

  const raw = process.env.REACT_APP_BACKEND_URL || "";

  // remove trailing slash
  let base = raw.endsWith("/") ? raw.slice(0, -1) : raw;

  // remove /api or /api/v1 or /api/v1/mn if present
  base = base.replace(/\/api(\/v\d+)?(\/mn)?$/, "");

  return base;
};

export const getBackendBaseUrl = () => {
  const raw = process.env.REACT_APP_BACKEND_URL || "";

  // remove trailing slash
  let base = raw.endsWith("/") ? raw.slice(0, -1) : raw;

  // remove /api or /api/v1 or /api/v1/mn if present
  base = base.replace(/\/api(\/v\d+)?(\/mn)?$/, "");

  return base;
};
